import IJobSection from "../../interfaces/IJobSection";
import { useResultsContext } from "../../context/results-context";
import { CSSProperties, ReactNode } from "react";
import classNames from "classnames";

interface Props {
  section: IJobSection,
  className?: string,
  style?: CSSProperties,
  children?: ReactNode,
}

export function Section({section, className, style, children}: Props) {
  const {
    selectedSections,
  } = useResultsContext();
  const selected = selectedSections[section.id] ?? false;
  return (
    <div className={classNames(className, 'll-section', {
      'll-screen': section.screenOnly,
      'll-unselected': !selected,
    })} style={style}>{children}</div>
  )
}